<script setup>
	import { ref } from 'vue'
	import NavbarController from '@/components/NavbarController.vue'
	import Establishments from '@/views/Establishments.vue'
  import Establishment from '@/views/Establishment.vue'

	const nav = ref();

	function toPage(id) {
	  nav.value.push(Establishment, { id: id, nav: nav })
	}

</script>

<template>
  <NavbarController ref="nav">
    <template #default>
      <Establishments @push="toPage"/>
    </template>
  </NavbarController>
</template>